import config from '../config';

/** Attentive configuration. */
const attentive = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      enabled: false,
      scriptURL: 'https://qjnhs.teva.com/providers/atLabel/load',
      fallbackScriptURL: 'https://cdn.attn.tv/teva/dtag.js',

      /** Whether the marketing SMS opt-in checkbox is shown at checkout. */
      marketingSmsEnabled: false,

      /** Attentive sign-up source ID used for marketing SMS subscriptions. */
      signUpSourceId: ''
    }
  },
  'UGG-US': {
    default: { marketingSmsEnabled: true, signUpSourceId: '1047979' }
  },
  'HOKA-US': { default: { marketingSmsEnabled: true } },
  'TEVA-US': {
    default: {
      enabled: { default: false, prod: true },
      scriptURL: 'https://qjnhs.teva.com/providers/atLabel/load',
      fallbackScriptURL: 'https://cdn.attn.tv/teva/dtag.js',
      marketingSmsEnabled: true,
      signUpSourceId: '1026952'
    }
  },
  'AHNU-US': { default: { marketingSmsEnabled: true } },
  'UGG-COLLAB-US': { default: { marketingSmsEnabled: true } },
  KOOLABURRA: { default: { marketingSmsEnabled: true } }
});

export default attentive;
